/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect } from "react";
import classes from "./TicketLargeGroup.module.scss";
import * as ROUTES from "../../constants/routes";
import FormController from "../../components/FormController/FormController";
// import SeatingMap from '../../components/FormSelectYourSeat/SeatingMap';
// import SeatingMap from '../../components/FormSelectYourSeat/SeatingMap';

const TicketLargeGroup = (props) => {
  useEffect(() => {
    if (window.adobeAnalytics) {
      window.adobeAnalytics.t({
        pageName:
          "Washington Nationals: Tickets: Nationals Ticketfinder: Group tickets and experiences",
      });
    }
  }, []);
  return (
    <>
      <div className={classes.TicketLargeGroup}>
        {/* <SeatingMap
          seatsInfo={[{ name: 'fortyClassic' }]}
          seatInfoSelectedKey={0}
        /> */}
        <div className={classes.FormTitle}>
          2021 Group Tickets, Luxury Suites & Experiences
        </div>
        <div className={classes.content}>
          <p>
            Nationals games are the perfect event for companies, schools,
            non-profits, associations, and youth sports leagues. Reserving a
            group is easy, and a wide range of seating and pricing options is
            available, including luxury suites. Plus, you will get tons of great
            benefits:
          </p>
          <div className={classes.content_col}>
            <div className={classes.content_col_items}>
              {/* <div className={classes.content_col_item}>
                <img
                  src={require(`../../assets/images/icons/present.png`)}
                  alt=""
                />
                <span className={classes.red}>
                  Receive a FREE 50% Bonus Credit for Group Tickets or Luxury
                  Suites purchased by December 15, 2020*. Use your bonus credit
                  towards concessions, merchandise, aditional tickets and more!
                </span>
              </div> */}
              <div className={classes.content_col_item}>
                <img
                  src={require(`../../assets/images/icons/icons-2.png`)}
                  alt=""
                />
                <span>
                  Discounted tickets for groups of 13 or more - the larger the
                  group, the larger the savings!
                </span>
              </div>
              <div className={classes.content_col_item}>
                <img
                  src={require(`../../assets/images/icons/icons-3.png`)}
                  alt=""
                />
                <span>No per-ticket fees</span>
              </div>
              <div className={classes.content_col_item}>
                <img
                  src={require(`../../assets/images/icons/icons-1.png`)}
                  alt=""
                />
                <span>
                  Reserved seating, allowing your group to enjoy the game
                  together
                </span>
              </div>
              <div className={classes.content_col_item}>
                <img
                  src={require(`../../assets/images/icons/icons-7.png`)}
                  alt=""
                />
                <span>Scoreboard messages for groups of 50 or more</span>
              </div>
            </div>
            <div className={classes.content_col_items}>
              <div className={classes.content_col_item}>
                <img
                  src={require(`../../assets/images/icons/icons-5.png`)}
                  alt=""
                />
                <span>
                  Pregame hospitality areas and meeting space reservations
                  available
                </span>
              </div>
              <div className={classes.content_col_item}>
                <img
                  src={require(`../../assets/images/icons/icons-4.png`)}
                  alt=""
                />
                <span>
                  Unique on-field experiences available, including pregame
                  performances, first pitch, play ball announcement, lineup card
                  delivery, Presidents Race finish line, and more!
                </span>
              </div>
              <div className={classes.content_col_item}>
                <img
                  src={require(`../../assets/images/icons/icons-6.png`)}
                  alt=""
                />
                <span>
                  Personalized service from your dedicated Account Executive
                  makes your experience easy from your initial order through
                  your event on game day
                </span>
              </div>
            </div>
          </div>
          <h5>
            Your initial payment will prioritize you for access to the best
            seats and hottest games in 2021.{" "}
            {/* <span className={classes.red}>
              Plus, receive a FREE 50% Bonus Credit based on the amount you
              decide to pay by December 15, 2020.
            </span>{" "} */}
            Your initial payment will be applied to your final purchase. Click
            below to customize the size of your initial payment, choosing
            between increments of $100 for Group Tickets or increments of $1,000
            for Luxury Suites.
          </h5>
          <div className={classes.buttons}>
            <a
              href="https://purchase.tickets.com/buy/MLBEventInfo?agency=WSHV_DEPOSIT9&pid=8844906"
              rel="noopener noreferrer"
              target="_blank"
            >
              <div className={classes.greenButton}>Make Initial Payment</div>
            </a>
            <a
              onClick={() => {
                window.chatBtn();
              }}
            >
              <div className={classes.redButton}>
                Chat with a Nationals Representative
              </div>
            </a>
          </div>
          {/* <p className={classes.disclaimer}>
            *50% Bonus Credit calculated based on the amount paid towards
            qualifying new 2021 ticket purchases on or before December 15, 2020,
            less all associated fees. For 50% Bonus Credit program terms &
            conditions, please visit{" "}
            <a
              href="http://www.nationals.com/bonusterms"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.nationals.com/bonusterms
            </a>
            .
          </p> */}
        </div>
      </div>
      <FormController
        backTo={ROUTES.PAGE_1_LINK}
        nextTo={ROUTES.PAGE_3_LINK}
        startOver={ROUTES.PAGE_1_LINK}
        showBack={true}
        showStartOver={false}
        showSkip={false}
        showSubmit={false}
      />
    </>
  );
};

export default TicketLargeGroup;
